<template>
  <v-container fluid class="d-flex align-center justify-center">
    <v-layout class="d-flex align-center justify-center">
    <div class="wid-100">
        <v-row dense>
          <v-col cols="12">

            <div class="f-r pl-1">
              <v-btn
                small
                color="green lighten-2"
                class="white--text"
                @click="addBtnClicked"
              >추가</v-btn>
            </div>
            <div class="f-r">
              <v-btn
                small
                color="red lighten-2"
                class="white--text"
                @click="deleteBtnClicked"
              >선택 삭제</v-btn>
            </div>
          </v-col>
          <v-col cols="12" >
            <div >
              <v-data-table
                :headers="headers"
                :items="gridList"
                class="elevation-1 dTable-1"
                :items-per-page="20"
                hide-default-footer
                disable-pagination> 
                <template v-slot:[`item.select_yn`]="{ item }">
                  <v-checkbox
                    v-model="item.select_yn"
                    class="pa-0 ma-0"
                    hide-details
                    dense
                  ></v-checkbox>
                </template>
                <template v-slot:[`item.addr_sno`]="{ item }">
                  <v-text-field
                    class="pa-0 ma-0"
                    v-model="item.addr_sno"
                    hide-details
                    outlined
                    dense
                    hidden
                  ></v-text-field>
							  </template>
                <template v-slot:[`item.addr_type`]="{ item }">
                  <v-select
                    class="pa-0 ma-0"
                    v-model="item.addr_type"
                    :items="addrTypeList"
                    item-text="cmn_cd_nm"
                    item-value="cmn_cd"
                    hide-details
                    outlined
                    dense
                    @change="gridItemChanged(item)"
                  ></v-select>
							  </template>
                <template v-slot:[`item.recv_postm_yn_scr`]="{ item }">
                  <v-checkbox
                    v-model="item.recv_postm_yn_scr"
                    class="pa-0 ma-0"
                    hide-details
                    dense
                    @change="gridItemChanged(item)"
                  ></v-checkbox>
                </template>
                <template v-slot:[`item.zpcd`]="{ item }">
                  <v-text-field
                    class="pa-0 ma-0"
                    v-model="item.zpcd"
                    hide-details
                    outlined
                    dense
                    @change="gridItemChanged(item)"
                    append-icon="mdi-home-search"
                    @click:append="findZipcodeBtnClicked(item.odr)"
                  ></v-text-field>
							  </template>
                <template v-slot:[`item.addr`]="{ item }">
                  <v-text-field
                    class="pa-0 ma-0"
                    v-model="item.addr"
                    hide-details
                    outlined
                    dense
                    @change="gridItemChanged(item)"
                  ></v-text-field>
							  </template>
                <template v-slot:[`item.addr_dtl`]="{ item }">
                  <v-text-field
                    class="pa-0 ma-0"
                    v-model="item.addr_dtl"
                    hide-details
                    outlined
                    dense
                    @change="gridItemChanged(item)"
                  ></v-text-field>
							  </template>
                <template v-slot:[`item.addr_ref`]="{ item }">
                  <v-text-field
                    class="pa-0 ma-0"
                    v-model="item.addr_ref"
                    hide-details
                    outlined
                    dense
                    @change="gridItemChanged(item)"
                  ></v-text-field>
							  </template>
                <template v-slot:[`item.tel_no`]="{ item }">
                  <v-text-field
                    class="pa-0 ma-0"
                    v-model="item.tel_no"
                    hide-details
                    outlined
                    dense
                    @change="gridItemChanged(item)"
                  ></v-text-field>
							  </template>
                <!-- <template v-slot:[`item.findZipcode`]="{ item }">
								  <v-btn
                    small
                    color="blue lighten-2"
									  class="pa-0 ma-0 white--text"
									  hide-details
                    @click="findZipcodeBtnClicked(item.addr_sno)"
								  >우편번호 찾기</v-btn>
							  </template> -->
              </v-data-table>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: ["propParams"],
  data(){
    return {
      headers:[
        { text: '선택', value:'select_yn', width:"5%"},
        { text: '주소유형', value:'addr_type', width:"10%"},
        { text: '우편물수령여부', value:'recv_postm_yn_scr', width:"5%"},
        { text: '우편번호', value:'zpcd', width:"10%"},
        { text: '주소', value:'addr', width:"20%"},
        { text: '상세주소', value:'addr_dtl', width:"20%"},
        { text: '참고', value:'addr_ref', width:"10%"},
        { text: '전화번호', value:'tel_no', width:"10%"},
        // { text: '우편번호 찾기', value:'findZipcode', width:"10%"},
      ],
      gridList: [],
      addrTypeList: [],
      changedList: [],    // 추가, 수정된 목록
      loginMberSno: "",   // 로그인 멤버
      mberSno: "",     // 처리 대상 멤버
    }
  },
  created() {
    this.loginMberSno = this.$session.get("mberSno"); // 로그인 멤버
    this.mberSno = this.propParams.mberSno;           // 처리 대상 멤버

    this.getAddrTypeList();
    this.getMberAddrList();
  },
  methods: {
    async getAddrTypeList() {
      this.addrTypeList = await this.$getCmnCdList("addr_type");
    },
    // 주소 수정됨
    gridItemChanged(item) {
      this.itemChanged();
      // console.log("gridItemChanged : item.addr_sno : " + item.addr_sno);
      // 추가된 목록인 경우 -> [추가] 시 changedList에도 추가함
      if(item.addr_sno == null || item.addr_sno == "") {
        return;
      }

      let found = false;
      this.changedList.forEach((e) => {
        if(e.addr_sno == item.addr_sno) {
          found = true;
        }
      });

      if(!found) {
        this.changedList.push(item);
      }
    },
    findZipcodeBtnClicked(odr) {
      new window.daum.Postcode({
				oncomplete: (data) => {
          this.gridList.forEach((e) => {
            console.log("findZipcodeBtnClicked : ", odr, e);
            if(e.odr == odr) {
              e.zpcd = data.zonecode;
              e.addr = data.roadAddress;

              this.gridItemChanged(e);
            }
          })			
				},
			}).open();
    },
    getMberAddrList() {
			const params = new FormData();

      params.append("mber_sno", this.mberSno);

			this.$http.post("/admin/getMberAddrList", params).then((res) => {
        // console.log("gridList: " + this.gridList);
        res.data.result.forEach((e) => {
          e.select_yn = false;
          e.new_yn = false;
          // 우편물 수령 여부(recv_postm_yn)는 -> recv_postm_yn_scr 로 변경하여 그리드에 전달
          // -> 수정 저장 시 recv_postm_yn 값은 'Y'/'N' 으로 변경 시 true 로 인식되어 체크에 표시 됨
          e.recv_postm_yn_scr = e.recv_postm_yn == 'Y' ? true : false;
        });

        this.gridList = res.data.result;
        this.changedList = [];
			}).catch(function (error) {
					console.log(error);
				}
			);
    },
    deleteBtnClicked() {
      console.log("deleteAddr");

      // 선택 체크된 목록 확인 -> deleteList 에 추가
      let deleteList = [];
      let isSelected = false;

      // for(let i = 0; i < this.gridList.length; i++) {
      //   if(this.gridList[i].select_yn) {
      //     isSelected = true;

      //     if(!this.gridList[i].new_yn) {
      //       deleteList.push(this.gridList[i]);
      //     }
      //   }
      // }
      deleteList = this.gridList.filter((e) => {
        if(e.select_yn) isSelected = true;
        return e.select_yn && !e.new_yn;
      });

      // 데이터 검증
      // deleteList.forEach((e) => {
      //   console.log("deleteList: addr_sno[" + e.addr_sno + "]");
      // });

      // 선택된 항목이 없는 경우
      if(!isSelected) {
        alert("선택된 목록이 없습니다.");
        return;
      }

      if(confirm("삭제 후 목록을 다시 조회합니다.\n삭제하시겠습니까?")) {
        if(deleteList.length > 0) {
          let params = new URLSearchParams();
          
          params.append("deleteList", JSON.stringify(deleteList));

          this.$http.post("/admin/deleteMberAddrList", params).then((res) => {
            console.log(res.data);
            alert("삭제되었습니다.");
            // this.getMberAddrList();
            this.gridList = this.gridList.filter((e) => {
              return !(e.select_yn);
            });

            this.changedList = this.changedList.filter((e) => {
              return !(e.select_yn);
            });
          })
          .catch(function (error) {
              console.log(error);
            }
          );
        } 
        // 추가된 객체만 선택된 경우
        else {
          // this.getMberAddrList();
          this.gridList = this.gridList.filter((e) => {
            return !(e.select_yn);
          });

          this.changedList = this.changedList.filter((e) => {
            return !(e.select_yn);
          });
        }
      }
    },
    addBtnClicked() {
      let maxOdr = 0;

      this.gridList.forEach((e) => {
        if(e.odr > maxOdr) {
          maxOdr = e.odr;
        }
      });

      maxOdr++;

      this.gridList.push({new_yn:true, select_yn:false, addr_sno:"", mber_sno:this.mberSno, odr:maxOdr, addr_type:"", zpcd:"", addr:"", addr_dtl:"", addr_ref:"", recv_postm_yn_scr:false, tel_no:""});
      this.changedList.push(this.gridList[this.gridList.length - 1]);
      // 객체 복사가 필요하면 아래의 방법으로 해야 함
      //this.changedList.push({...this.gridList[this.gridList.length - 1]}); 
      // 객체 안에 또 객체가 있을 경우 아래의 방법으로 해야 함
      // JSON.parse(JSON.stringify(item))

      // 데이터 검증
      // this.changedList.forEach((e) => {
      //   console.log("changedList: addr_sno[" + e.addr_sno + "]");
      // });
    },
    saveBtnClicked() {
      console.log("saveAddr");

      if(this.changedList.length == 0) {
        // alert("수정된 내용이 없습니다.");
        return;
      }

      // true/false -> 'Y'/'N' 변환
      this.changedList.forEach((e) => {
        e.new_yn = e.new_yn == true ? 'Y' : 'N';
        e.recv_postm_yn = e.recv_postm_yn_scr == true ? 'Y' : 'N';
      });

      // if(confirm("저장하시겠습니까?")) {
        let params = new URLSearchParams();

        params.append("login_mber_sno", this.loginMberSno);
        params.append("changedList", JSON.stringify(this.changedList));

        this.$http.post("/admin/upsertMberAddrList", params).then((res) => {
          console.log(res.data);
          // alert("저장되었습니다.");
          
          this.getMberAddrList();
        }).catch(function (error) {
            console.log(error);
        });
      // }
    },
    itemChanged() {
      this.$emit('tabChanged', "addressTab");
    }
  }
}
</script>

<style>

</style>